import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "signupModalElement"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Signing Up", -1)
const _hoisted_6 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_7 = {
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close btn-sm",
  "data-bs-dismiss": "alert",
  "aria-label": "Close"
}, null, -1)
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "row mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "signupEmail",
  class: "col-sm-2 col-form-label"
}, "Email *", -1)
const _hoisted_12 = { class: "col-sm-10" }
const _hoisted_13 = { class: "row mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "signupUsername",
  class: "col-sm-2 col-form-label"
}, "Username *", -1)
const _hoisted_15 = { class: "col-sm-10" }
const _hoisted_16 = { class: "row mb-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "signupPassword",
  class: "col-sm-2 col-form-label"
}, "Password *", -1)
const _hoisted_18 = { class: "col-sm-5" }
const _hoisted_19 = { class: "col-sm-5" }
const _hoisted_20 = { class: "invalid-feedback" }
const _hoisted_21 = { class: "row mb-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "signupName",
  class: "col-sm-2 col-form-label"
}, "Name", -1)
const _hoisted_23 = { class: "col-sm-5" }
const _hoisted_24 = { class: "col-sm-5" }
const _hoisted_25 = { class: "modal-footer" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary col-2"
}, "OK", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args))),
      class: _normalizeClass(_ctx.btnClass || 'btn btn-link'),
      ref: "signupModalTrigger"
    }, _toDisplayString(_ctx.btnText || "Sign up?"), 3),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              "aria-label": "Close"
            })
          ]),
          (_ctx.errors.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row",
                    key: error
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", null, _toDisplayString(error.message || error), 1),
                      _hoisted_8
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            class: "was-validated",
            method: "post",
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["stop","prevent"]))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                    type: "email",
                    class: "form-control",
                    id: "signupEmail",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.email]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.username) = $event)),
                    type: "text",
                    class: "form-control",
                    id: "signupUsername",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.username]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event)),
                    type: "password",
                    class: _normalizeClass(["form-control", {'is-invalid': !_ctx.passwordAndRepeatAreSame}]),
                    id: "signupPassword",
                    required: ""
                  }, null, 2), [
                    [_vModelText, _ctx.password]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.repeatPassword) = $event)),
                    type: "password",
                    class: _normalizeClass(["form-control", {'is-invalid': !_ctx.passwordAndRepeatAreSame}]),
                    id: "signupRepeatPassword",
                    placeholder: "Repeat the password",
                    required: ""
                  }, null, 2), [
                    [_vModelText, _ctx.repeatPassword]
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_20, " Passwords must be the same. ", 512), [
                  [_vShow, !_ctx.passwordAndRepeatAreSame]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.firstname) = $event)),
                    type: "text",
                    class: "form-control",
                    id: "signupFirstName",
                    placeholder: "First name"
                  }, null, 512), [
                    [_vModelText, _ctx.firstname]
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.lastname) = $event)),
                    type: "text",
                    class: "form-control",
                    id: "signupLastName",
                    placeholder: "Last name"
                  }, null, 512), [
                    [_vModelText, _ctx.lastname]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary col-2",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, "Cancel")
            ])
          ], 32)
        ])
      ])
    ], 512)
  ], 64))
}